import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { PolotnoStoreActivePageKeys, usePolotnoActivePageState } from '@/pages/AdvancedEditor/hooks/polotno-store';
import { DEFAULT_VOICE, languageToVoicesMap as languageToVoicesMapState } from '@/state/presenters';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

export const useSyncNewPageInitials = () => {
    const { store } = useAdvancedEditorContext();
    const [selectedVoice, setSelectedVoice] = usePolotnoActivePageState(PolotnoStoreActivePageKeys.ttsSelectedVoice);
    const languageToVoicesMap = useRecoilValue(languageToVoicesMapState);

    useEffect(() => {
        // Set default voice for new pages
        if (!selectedVoice) {
            const voices = Object.values(languageToVoicesMap).flat();
            const language = DEFAULT_VOICE.language;

            const defaultVoice = voices.find(voice => voice.language === language) || voices[0] || null;

            setSelectedVoice(defaultVoice);
        }
    }, [store.pages?.length]);
};
